module.exports = function(gaugeInfo, Uri, ebayCookies, metrics) { // jshint ignore:line 

/*
* Context of Site Speed:
*   context: {
*     gaugeInfo: <gaugeInfo>,
*     beacon: <beacon uri>,
*     cookies: <cookies>
*   }
*
* Interface Spec:
*  beacon should contain APIs:
*    - function add(beacon, value) {...}
*    - function remove(beacon) {...}
*    - function getUrl() {...; return <url>; }
*
*  cookies should contain APIs:
*    - function readCookie(cookie, cookielet) {...; return <value of cookielet>;}
*    - function writeCookielet(cookie, cookielet, value) {...}
*    - function getBitFlag(bits, position) {...; return <value of positioned bit>;}
*    - function setBitFlag(bits, position, 1|0) {...}
*
*  errors should contain APIs:
*    - function init() {...}
*    - function getLength() {...; return <length of errors>;}
*    - function getString() {...; return <error strings>;}
*
*  metrics should contain APIs:
*    - function getEntries() {...; return <[{'key':<key>,'value':<value>},...] of metrics>;}
*
*/

function SiteSpeed(context) {

    function getResourceTimingTag() {

        var validInitiators = {'all':1, 'link':2, 'script':3, 'img':4, 'css':5, 'iframe':6, 'object':7, 'embed':8, 'svg':9, 'xmlhttprequest':10};

        function isValidInitiator(initiator) {
            return validInitiators.hasOwnProperty(initiator);
        }
        function sort(ranges) {
            if (!ranges) {
                return [];
            }
            ranges.sort(function(a, b){
                var a_start = a[0], a_end = a[1];
                var b_start = b[0], b_end = b[1];
                return (a_start == b_start
                   ? (a_end == b_end
                    ? 0
                    : (a_end < b_end ? -1 : 1))
                   : (a_start < b_start ? -1 : 1));
            });
            return ranges;
        }
        // Parameter ranges is a sorted range array: [[start, end], ... ]
        // Return startOffset_range_duration
        // startOffset is the minimum start of the ranges.
        // duration is 'maximum end' - 'minimum start' of the ranges.
        // range is all the ranges which remove the overlaps and gaps
        // for more refer
        function join(ranges) {
            function overlap(a, b) {
                var left = Math.max(a[0], b[0]);
                var right = Math.min(a[1], b[1]);
                return (left <= right ? true : false);
            }
            if (!ranges || ranges.length == 0) {
                return '';
            }
            var range = 0;
            var current = [ranges[0][0], ranges[0][1]];
            var startOffset = ranges[0][0];
            var maxEnd = ranges[0][1];
            for (var i=1; i<ranges.length; i++) {
                var target = ranges[i];
                maxEnd = Math.max(maxEnd, target[1]);
                if (overlap(current, target)) {
                    current[1] = Math.max(current[1], target[1]);
                } else {
                    range += (current[1] - current[0]);
                    current = [target[0], target[1]];
                }
            }
            range += (current[1] - current[0]);
            //startOffset_range_duration
            return startOffset.toFixed(0) + '_' + range.toFixed(0) + '_' + (maxEnd-startOffset).toFixed(0);
        }

        //ignore if browser does not support resource timing API
        var performance = getPerformance();
        if ( !performance ||
         !('getEntriesByType' in performance) ||
         !(performance.getEntriesByType('resource') instanceof Array)) {
            return '';
        }

        var entries = performance.getEntriesByType('resource');

        if (!entries) {
            return '';
        }
        var allHosts = {};
        var ebayHosts = {};
        var nonEbayHosts = {};
        var hosts = {};
        entries.forEach(function(entry, i){
            var requestStart = entry.requestStart;
            //cross domain case, use fetchStart instead
            if (!requestStart) {
                requestStart = entry.fetchStart;
            }

            //ignore not valid hostname case
            if(entry.name.indexOf("http://") != 0 && entry.name.indexOf("https://") != 0)
                return;

            var host = entry.name.split('/')[2];
            var theInitiatorType = entry.initiatorType;
            //work around since notice that firefox use 'subdocument' instead of 'iframe'
            if(theInitiatorType === 'subdocument') {
                theInitiatorType = 'iframe';
            }

            //validate initiator type and range
            if(!isValidInitiator(theInitiatorType) || requestStart > entry.responseEnd) {
                return;
            }

            // add to specific host case
            hosts[host] = hosts[host] || {};
            hosts[host][theInitiatorType] = hosts[host][theInitiatorType] || [];
            hosts[host][theInitiatorType].push([requestStart, entry.responseEnd]);
            hosts[host]['all'] =  hosts[host]['all'] || [];
            hosts[host]['all'].push([requestStart, entry.responseEnd]);
            //  add to all hosts case
            allHosts[theInitiatorType] = allHosts[theInitiatorType] || [];
            allHosts[theInitiatorType].push([requestStart, entry.responseEnd]);
            allHosts['all'] =  allHosts['all'] || [];
            allHosts['all'].push([requestStart, entry.responseEnd]);
            if (host.indexOf('ebay') > -1) {
                ebayHosts[theInitiatorType] = ebayHosts[theInitiatorType] || [];
                ebayHosts[theInitiatorType].push([requestStart, entry.responseEnd]);
                ebayHosts['all'] = ebayHosts['all'] || [];
                ebayHosts['all'].push([requestStart, entry.responseEnd]);
            } else {
                nonEbayHosts[theInitiatorType] = nonEbayHosts[theInitiatorType] || [];
                nonEbayHosts[theInitiatorType].push([requestStart, entry.responseEnd]);
                nonEbayHosts['all'] = nonEbayHosts['all'] || [];
                nonEbayHosts['all'].push([requestStart, entry.responseEnd]);
            }
        });

        var rsTimingTag = '';
        // generate beacon url for fixed part: nonEbayHosts, ebayHosts and allHosts
        [['nonebay', nonEbayHosts],
        ['ebay',  ebayHosts],
        ['*',  allHosts]].forEach(function(entry, i){
            if (rsTimingTag) rsTimingTag += '!';
            rsTimingTag += entry[0];

            Object.keys(validInitiators).forEach(function(initiator, initiatorIndex){
                rsTimingTag += '~' + join(sort(entry[1][initiator]));
            });

        });
        // generate beacon url for all individual hosts
        Object.keys(hosts).forEach(function(host, i){
            rsTimingTag += '!' + host;

            Object.keys(validInitiators).forEach(function(initiator, initiatorIndex){
                rsTimingTag += '~' + join(sort(hosts[host][initiator]));
            });
        });
        return rsTimingTag;
    }

    //Get 'window.performance.timing'
    function getTiming() {
        var performance = getPerformance();
        return performance ? performance.timing : 'undefined';
    }

    //Get 'window.performance'
    function getPerformance() {
        return window.performance || window.msPerformance || window.webkitPerformance || window.mozPerformance;
    }

    this.init = function () {

        // 1. initialize gaugeInfo: ut, bf, sent, ld, wt, ex3, ct21
        var gaugeInfo = context.gaugeInfo;
        if (typeof(gaugeInfo) != 'undefined') {
            var bf = 0;
            var ut = null;
            var cookies = context.cookies;
            if (cookies) {
                var sbf = cookies.readCookie("ebay","sbf");
                if (sbf) {
                    bf = cookies.getBitFlag(sbf, 20);
                }
                if (!bf) {
                    cookies.writeCookielet("ebay","sbf", cookies.setBitFlag(sbf, 20, 1));
                }
                ut = cookies.readCookie('ds2', 'ssts');
            }
            gaugeInfo.ut = ut;
            gaugeInfo.bf = bf;
            gaugeInfo.sent = false;
            gaugeInfo.ld = false;
            gaugeInfo.wt = 0;
            gaugeInfo.ex3 = 0;
            gaugeInfo.ct21 = 0;
            if (typeof(gaugeInfo.iLoadST) == 'undefined') {
                gaugeInfo.iLoadST = Date.now();
            }

            var errors = context.errors;
            if (errors) {
                errors.init();
            }

            // initialize resource timing buffer size
            var performance = getPerformance();
            if (gaugeInfo.bRsTiming && 'getEntriesByType' in performance) {
                performance.setResourceTimingBufferSize = performance.setResourceTimingBufferSize
                                                       || performance.webkitSetResourceTimingBufferSize
                                                       || performance.mozSetResourceTimingBufferSize
                                                       || performance.msSetResourceTimingBufferSize
                                                       || performance.oSetResourceTimingBufferSize
                                                       || performance.webkitSetResourceTimingBufferSize;
                if (typeof performance.setResourceTimingBufferSize === "function") {
                    performance.setResourceTimingBufferSize(300); //expand the buffer to 300
                }
            }

        }

    }

    this.onLoad = function () {

        // 1. initialize gaugeInfo: ld, wt, ex3, ct21, jseaa, jseap, ct1chnk, jsljgr3, svo, jsljgr1, slo, ua
        // 2. send beacon if browser is ff, Safari or Chrome
        var gaugeInfo = context.gaugeInfo;
        if (typeof(gaugeInfo) != 'undefined') {
            var cookies = context.cookies;
            if (cookies) {
                var sbf = cookies.readCookie('ebay', 'sbf');
                if (sbf) {
                    cookies.writeCookielet('ebay', 'sbf', cookies.setBitFlag(sbf, 20, 1));
                }
            }

            gaugeInfo.ld = true;

            var now = Date.now();
            gaugeInfo.wt = now;
            gaugeInfo.ex3 = now;
            gaugeInfo.ct21 = now - gaugeInfo.iST;

            var timing = getTiming();
            var beacon = context.beacon;
            if (timing) {
                beacon.add('ex3', now - timing.navigationStart); // end to end at client, also log to cal tx
                beacon.add('jseaa', now - timing.responseStart); // client rendering = ct21, was ctidl before
                beacon.add('jseap', timing.responseStart - timing.navigationStart); // first byte time (jsebca before not in batch)
                beacon.add('ct1chnk', timing.domComplete - timing.responseStart); // dom complete
                beacon.add('jsljgr3', timing.domainLookupEnd - timing.domainLookupStart); // dns lookup time
                beacon.add('svo', timing.connectEnd - timing.connectStart); // connection time, also log to cal tx
                beacon.add('jsljgr1', timing.responseStart - timing.requestStart); // request time
                beacon.add('slo', timing.responseEnd - timing.responseStart); // content download time

                // SSL negotiation time
                if (timing.secureConnectionStart) {
                    var i_ssl = timing.connectEnd - timing.secureConnectionStart;
                    if (i_ssl > 0) {
                        beacon.add('i_ssl', i_ssl);
                    }
                }
            }

            beacon.add('dcon', document.getElementsByTagName("*").length); // DOM count onload
            beacon.add('fsom', gaugeInfo.fsom ? 'y' : 'n'); // value from `_fsom` cookie (when available)

            // Adding signals by type
            var performance = getPerformance();
            if (performance && 'getEntriesByType' in performance) {
                // Observer - longtask
                var o_lt = 0,
                    o_ltn = '',
                    o_ltu = '',
                    o_cls = 0,
                    o_lcp = 0,
                    observerLongtask = new PerformanceObserver(function(list) {
                        var perfEntries = list.getEntries();
                        if (window.__tti && window.__tti.e) {
                            window.__tti.e = window.__tti.e.concat(perfEntries);
                        } else{
                            window.__tti = { e: [].concat(perfEntries) };
                        }
                        perfEntries.forEach(function (perfEntry) {
                            if (perfEntry &&
                                perfEntry.duration &&
                                perfEntry.duration > o_lt
                            ) {
                                o_lt = Math.round(perfEntry.duration);
                                o_ltn = perfEntry.name;
                                o_ltu = perfEntry.attribution &&
                                                      perfEntry.attribution[0] &&
                                                      perfEntry.attribution[0].containerSrc;
                            }
                        });
                        beacon.add('o_lt', o_lt); // Observer Longest Longtask
                        beacon.add('o_ltn', o_ltn); // Observer Longest Longtask Name
                        beacon.add('o_ltu', o_ltu); // Observer Longest Longtask URL
                        beacon.add('o_ltc', window.__tti.e.length || 0); // Observer Longtask Counter
                        beacon.add('dcpon', document.getElementsByTagName("*").length); // DOM count post onload II
                    }),
                    observerFirstInput = new PerformanceObserver(function(list) {
                        for (var entry of list.getEntries()) {
                            beacon.add('o_fid', entry.processingStart - entry.startTime); // Observer First Input Delay
                        }
                    }),
                    observerLayoutShift = new PerformanceObserver(function(list) {
                        for (var entry of list.getEntries()) {
                            if (!entry.hadRecentInput) {
                                o_cls += entry.value;
                                beacon.add('o_cls', o_cls); // Observer Cumulative Layout Shift
                            }
                        }
                    }),
                    observerLargetsContentfulPaint = new PerformanceObserver(function(list) {
                        for (var entry of list.getEntries()) {
                            if (o_lcp < entry.startTime) {
                                o_lcp = entry.startTime;
                                beacon.add('o_lcp', Math.round(o_lcp)); // Observer Largets Contentful Paint
                            }
                        }
                    });

                try{
                    observerFirstInput.observe({ type: 'first-input', buffered: true });
                    observerLayoutShift.observe({ type: 'layout-shift', buffered: true });
                    observerLongtask.observe({ entryTypes: ['longtask'], buffered: true });
                    observerLargetsContentfulPaint.observe({ type: 'largest-contentful-paint', buffered: true });
                } catch (e) {
                    // Do nothing if the browser doesn't support this API.
                }
                window.setTimeout(function(){
                    // Paint
                    var paintMetrics = performance.getEntriesByType('paint'),
                        firstContentfulPaint = 0;
                    if(paintMetrics !== undefined && paintMetrics.length > 0) {
                        paintMetrics.forEach(function (paintMetric) {
                            // provides first-paint & first-contentful-paint
                            // which will be convert to
                            // i_firstpaint & i_firstcontentfulpaint respectively
                            beacon.add('i_'+paintMetric.name.replace(/\-/g, ''), Math.round(paintMetric.startTime));
                            if (paintMetric.name === 'first-contentful-paint') {
                                firstContentfulPaint = Math.round(paintMetric.startTime);
                            }
                        });
                    }
                    // Navigation
                    var navMetrics = performance.getEntriesByType('navigation'),
                        navCaptured = navMetrics[navMetrics.length - 1];
                    if (navCaptured) {
                        beacon.add('nvt_dcl', Math.round(navCaptured.domContentLoadedEventEnd - navCaptured.domContentLoadedEventStart)); // DOM content loaded
                        beacon.add('nvt_di', Math.round(navCaptured.domInteractive)); // DOM interactive
                        beacon.add('nvt_dc', Math.round(navCaptured.domComplete)); // DOM complete
                        beacon.add('nvt_oe', Math.round(navCaptured.loadEventEnd - navCaptured.loadEventStart)); // Onload execution
                        beacon.add('nvt_rc', navCaptured.redirectCount || '0'); // Redirect count
                    }

                    if ("ttiPolyfill" in window) {
                        ttiPolyfill.getFirstConsistentlyInteractive().then(function(tti){
                            beacon.add('o_tti', Math.round(tti)); // Observer Time to Interactive
                            if (window.__tti && window.__tti.e) {
                                var firstCPUIdle,
                                    longtaskCollection = [];
                                window.__tti.e.forEach(function (e, i) {
                                    if (
                                        e.startTime > firstContentfulPaint &&
                                        (firstCPUIdle === undefined || (e.startTime + e.duration + 50) < firstCPUIdle)
                                    ) {
                                        firstCPUIdle = e.startTime + e.duration;
                                    }
                                    longtaskCollection.push(
                                        's_' + Math.round(e.startTime) +
                                        '|t_' + Math.round(e.duration) +
                                        '|n_' + e.name +
                                        '|u_' +
                                        (e.attribution &&
                                        e.attribution[0] &&
                                        e.attribution[0].containerSrc)
                                    );
                                });
                                if (firstCPUIdle) {
                                    beacon.add('o_fci', Math.round(firstCPUIdle)); // Observer First CPU Idle
                                }
                                if (longtaskCollection.length > 0) {
                                    beacon.add('o_lcd', longtaskCollection.join(',')); // Observer Longtask Collection Details
                                }
                            }
                        });
                    }
                },1);
            }

            var defer = 0;
            if(gaugeInfo.deferExecInMs){
                defer = gaugeInfo.deferExecInMs;
            }

            // lock down resource timing buffer size upon onload event
            var performance = getPerformance();
            if (gaugeInfo.bRsTiming && 'getEntriesByType' in performance) {
                performance.setResourceTimingBufferSize = performance.setResourceTimingBufferSize
                                                        || performance.webkitSetResourceTimingBufferSize
                                                        || performance.mozSetResourceTimingBufferSize
                                                        || performance.msSetResourceTimingBufferSize
                                                        || performance.oSetResourceTimingBufferSize
                                                        || performance.webkitSetResourceTimingBufferSize;
                if (typeof performance.setResourceTimingBufferSize === "function") {
                    var max = performance.getEntriesByType('resource').length;
                    performance.setResourceTimingBufferSize(max - 1 > 0 ? max - 1 : 0);
                }
            }
            // Fire beacon onload when `_FireBeaconOnload=true`
            if (
                URLSearchParams &&
                (new URLSearchParams(window.location.search)).get('_FireBeaconOnload') === 'true'
            ) {
                fireSpeedBeacon = false;
                this.sendBeacon('onload', false, isSendBeaconAPIAvailable());
            }
            //Mobile Safari does not call beforeunload and pagehide has a bug with sendBeacon API
            // if (isMobileSafari() || ((isSafari() || isFireFox()) && !isSendBeaconAPIAvailable())) { //For old FireFox and current Safari
            // var this_ = this;
            // setTimeout(function () {
            //    this_.sendBeacon('onload', false, isSendBeaconAPIAvailable());
            // }, defer);
            // }
        }
    }

    this.onBeforeunload = function () {

        // 1. write cookie
        // 2. send beacon

        var cookies = context.cookies;
        if (cookies) {
            cookies.writeCookielet("ds2", "ssts", Date.now());
        }

        this.sendBeacon("unload", false, isSendBeaconAPIAvailable());

    }

    this.sendBeacon = function (event, immediate, useSendBeaconAPI) {

        // 1. set params: ex2, ex1, ct21, ctb, st1a, jslcom, jseo, jsllib1, jsllib2, jsllib3, jslpg, jslss, jslsys, sgwt, i_30i, (s_rstm), sgbld, emsg, i_nev2elc
        // 2. send beacons
        var gaugeInfo = context.gaugeInfo;
        if (typeof(gaugeInfo) == 'undefined' || gaugeInfo.sent == 1) {
        	return;
        }

        var beacon = context.beacon;

        if (immediate) {

            if (gaugeInfo.bRsTiming) {
                var s_rstm = getResourceTimingTag();
                if (s_rstm) {
                    beacon.add('s_rstm', s_rstm);
                }
            }

            var errors = context.errors;
            if (errors && errors.getLength()) {
                beacon.add('sgbld', errors.getLength());
                beacon.add('emsg', errors.getString());
            }

            var timing = getTiming();
            if (timing) {
                var i_nve2elc =  timing.loadEventEnd - timing.navigationStart;
                if (i_nve2elc > 0) {
                    beacon.add('i_nve2elc', i_nve2elc);
                }
            }

            if (gaugeInfo.bf) {
                beacon.remove('st1');
            }

            var beaconURL = beacon.getUrl();
            if (beaconURL.indexOf('?') < 0) {
                beaconURL += '?now=' + Date.now();
            }

            var metrics = context.metrics;
            if (metrics) {
                var entries = metrics.getEntries();
                for (var index in entries) {
                    beaconURL += '&' + entries[index].key + '=' + entries[index].value;
                }
            }

            // fire beacon
            if (useSendBeaconAPI) {
                navigator.sendBeacon(beaconURL);
            } else {
                new Image().src = beaconURL;
            }

            // mark sent
            gaugeInfo.sent = 1;

            return;
        }

        // earlier exit case
        if (!gaugeInfo.ld) {
            beacon.add('ex2', Date.now() - gaugeInfo.iST);
            this.sendBeacon(event, true, useSendBeaconAPI);
        	return;
        }

        if (gaugeInfo.bf) {
            // cached page case
            beacon.add('ex1', '1');
        } else {
            beacon.add('ct21', gaugeInfo.ct21);
            if (gaugeInfo.iLoadST) {
                beacon.add('ctb', gaugeInfo.iLoadST - gaugeInfo.iST);
            }
            if (gaugeInfo.st1a) {
                beacon.add('st1a', gaugeInfo.st1a);
            }
            if (gaugeInfo.aChunktimes && gaugeInfo.aChunktimes.length) {
            	// progressive rendering chunks
                beacon.add('jslcom', gaugeInfo.aChunktimes.length);
                var chunkTimeParamNames = [
                    "jseo",
                    "jsllib1",
                    "jsllib2",
                    "jsllib3",
                    "jslpg",
                    "jslss",
                    "jslsys"
                ];
                var chunkTimesLen = gaugeInfo.aChunktimes.length;
                for (var i = 0, chunkTimeParamName; i < chunkTimesLen; i++) { // jshint ignore:line
                    if ((chunkTimeParamName = chunkTimeParamNames[i])) {
                        beacon.add(chunkTimeParamName, gaugeInfo.aChunktimes[i]);
                    }
                }
            }
        }

        if (event == 'onload') {
            if (gaugeInfo.deferExecInMs > 0) {
                gaugeInfo.wt = Date.now() - gaugeInfo.wt;
                beacon.add('sgwt', gaugeInfo.wt);
                beacon.add('i_30i', gaugeInfo.wt);
            } else {
                gaugeInfo.wt = 0;
            }
        } else {
            gaugeInfo.wt = Date.now() - gaugeInfo.wt;
            beacon.add('sgwt', gaugeInfo.wt);
        }

        if (gaugeInfo.wt < 60000 * 20) { // ignore > 20 min to prevent incorrect st21
            this.sendBeacon(event, true, useSendBeaconAPI);
        }

    }

    // function isMobileSafari() {
    //     return /iP(ad|hone|od).+Version\/[\d\.]+.*Safari/i.test(navigator.userAgent);
    // }

    function isSendBeaconAPIAvailable() {
        return 'sendBeacon' in navigator;
    }

    // function isFireFox() {
    //     return navigator.userAgent.indexOf("Firefox/") > 0;
    // }

    // function isSafari() {
    //     return navigator.userAgent.indexOf("Safari") > 0 && navigator.userAgent.indexOf("Chrome") < 0;
    // }
}

var uri = Uri.create(gaugeInfo.sUrl);
var errors = [];
var context = {
    gaugeInfo: gaugeInfo,
    cookies: ebayCookies,
    beacon: {
        add: function(beacon, value) {
            return uri.params[beacon] = value;
        },
        remove: function(beacon) {
            delete uri.params[beacon];
        },
        getUrl: function() {
            for (var ps in uri.params) {
                if (Array.isArray(uri.params[ps])) {
                    var undefinedIndex = uri.params[ps].indexOf(undefined);
                    if (undefinedIndex > -1) {
                        uri.params[ps].splice(undefinedIndex, 1);
                    }
                }
            }
            return uri.getUrl();
        }
    },
    errors: {
        init: function() {
            window.onerror = (function (oldHandler, errors) {
                return function(message, url, lineNumber) {
                    errors.push({message: message, url: url, lineNumber: lineNumber});
                    if (oldHandler) {
                        return oldHandler.apply(this, arguments);
                    } else {
                        return false;
                    }
                }
            }) (window.onerror, errors);
        },
        getLength: function() {
            return errors.length;
        },
        getString: function() {
            return (function(errors) {
                var parts = [];
                for (var i = 0, len = errors.length; i < len; i++) {
                    var err = errors[i];
                    parts.push("js-err-line-" + err.lineNumber + "-msg-" + err.message + "-url-" + err.url);
                }
                return parts.join("|");
            })(errors);
        }
    },
    metrics: {
        getEntries: function() {
            var entries = [];
            var _metrics = metrics.get();
            if (typeof(_metrics) != "undefined") {
                for (var key in _metrics) {
                    if (_metrics.hasOwnProperty(key)) {
                        entries.push({"key": key, "value": _metrics[key]});
                    }
                }
            }
            return entries;
        }
    }
};

var script = new SiteSpeed(context);
script.init();

var fireSpeedBeacon = true;
window.addEventListener('load', function() {
    script.onLoad();
});
window.addEventListener('onpagehide' in window ? 'pagehide' : 'beforeunload', function() {
    if(fireSpeedBeacon) {
        fireSpeedBeacon = false;
        script.onBeforeunload();
    }
});
window.addEventListener('unload', function() {
    if(fireSpeedBeacon) {
        script.onBeforeunload();
    }
});

}
